import { render, staticRenderFns } from "./MedicationTableRow.vue?vue&type=template&id=128ef6e4&scoped=true"
import script from "./MedicationTableRow.vue?vue&type=script&lang=js"
export * from "./MedicationTableRow.vue?vue&type=script&lang=js"
import style0 from "./MedicationTableRow.vue?vue&type=style&index=0&id=128ef6e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ef6e4",
  null
  
)

export default component.exports